var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-card',{attrs:{"title":"Device Detail","header":_vm.deviceDetails,"data":_vm.singleDevice,"height":_vm.row1Height}})}
var staticRenderFns = []

export { render, staticRenderFns }